import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RouteStatus } from '../../../../@core/models/dto-routestatus';
import { DTOShipment } from '../../../../@core/models/DTOShipment';
import { DTOStop } from '../../../../@core/models/DTOStop';
import { Stop } from '../../../../@core/models/live-route';
import { ApiProvider } from '../../../../@core/providers/api.provider';
import { LocationService } from '../../../../@core/services/location.service';
import { ShipmentService } from '../../../../@core/services/shipment.service';
import { StopService } from '../../../../@core/services/stop.service';
import { CryptoService } from '../../../../@core/services/encrypt.service';

@Component({
  selector: 'crm-routes',
  templateUrl: './crm-routes.component.html',
  styleUrls: ['./crm-routes.component.scss']
})
export class CrmRoutesComponent implements OnInit {
  sub: Subscription;
  shipment: DTOShipment;
  waybill: string;
  userId: string;
  lang: string;
  key: string;
  encryptedKey: string;
  isNotAuthorized: boolean = false;
  StopsList: Stop[];
  PickupList: Stop[];
  stopDataSource = new MatTableDataSource<DTOStop>(null);
  pickupDataSource = new MatTableDataSource<DTOStop>(null);
  displayedStopColumns: string[] = [
    'StatusIcon',
    'No_Stop',
    'Address.Postal_Code',
    'CustomerName',
    'Lr_Name',
    'Address.Address1',
    'ETA',
    'Forecasted_Arrival_Time',
    'Arrival_Time'
  ];

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private apiProvider: ApiProvider,
    private route: ActivatedRoute,
    public _stopService: StopService,
    public _locationService: LocationService,
    private shipmentService: ShipmentService,
    private readonly cryptoService: CryptoService
  ) {}

  async ngOnInit() {

    const querystringParams = new URLSearchParams(window.location.search);
    
    this.waybill = querystringParams.get('waybill');
    this.userId = querystringParams.get('userId');
    this.encryptedKey = querystringParams.get('key');

    const decryptedKey = await this.cryptoService.decryptBase64(this.encryptedKey, "let encrypt = this.encryptService.encrypt(chaine);")
    this.key = decryptedKey;

    this.lang = querystringParams.get('UserLanguage');
    this.isNotAuthorized = false;
    if (this.waybill === '' || this.waybill === null || !Number(this.waybill))
      this.router.navigateByUrl(
        `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
      );

    this.shipmentService
      .GetShipment(Number(this.waybill), this.userId, this.key)
      .subscribe(
        (res) => {
          if (res === null || res === undefined)
            this.router.navigateByUrl(
              `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
            );

          if (res.Sender === null) {
            this.isNotAuthorized = true;
          } else {
            this.shipment = res;
            if (this.shipment.Stops) {
              this.stopDataSource = new MatTableDataSource<DTOStop>(
                this.shipment.Stops.StopsList
              );
              this.StopsList = this.shipment.Stops.StopsList;
            }
            if (this.shipment.PickupStops) {
              this.pickupDataSource = new MatTableDataSource<DTOStop>(
                this.shipment.PickupStops.StopsList
              );
              this.PickupList = this.shipment.PickupStops.StopsList;
            }
          }
        },
        (err: HttpErrorResponse) => {
          if (err.status === 400 || err.status === 404) {
            this.router.navigateByUrl(
              `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
            );
          }
        }
      );
  }

  zoomToMap(stop: Stop) {
    const location: any = {
      Latitude: stop.Address.Latitude,
      Longitude: stop.Address.Longitude,
      zoom: 16
    };
    this._locationService.setLocation(location);
  }

  getStatus(routeStatus: RouteStatus, stop: Stop): string {
    //let _routeStatus = routeStatus.RouteStatus;
    const _minRouteStatus = stop.Min_Live_Route_Status;
    const _maxRouteStatus = stop.Max_Live_Route_Status;
    // const Sectors: SectorCompress = this._sectorService.currentSectorValue;
    let _stopStatus: string = '000';
    let _cssclass: string = 'received';

    /*if (Sectors) {
      for (const oneroute of Sectors.RouteCompress) {
        if (oneroute.Route_ID === stop.Route_ID) {
          _routeStatus = String(oneroute.LiveRouteStatus);
          break;
        }
      }
    }*/

    _stopStatus = `0${String(_maxRouteStatus)}${String(_maxRouteStatus)}`;

    switch (_stopStatus) {
      case '000': {
        _cssclass = 'received';
        break;
      }
      case '001': {
        _cssclass = 'intransit';
        break;
      }
      case '011': {
        _cssclass = 'intransit';
        break;
      }
      case '111': {
        _cssclass = 'inroute';
        break;
      }
      case '022': {
        _cssclass = 'inroute';
        break;
      }
      case '033': {
        _cssclass = 'failed';
        break;
      }
      case '044': {
        _cssclass = 'shipped';
        break;
      }
      case '444': {
        _cssclass = 'shipped';
        break;
      }
      case '422': {
        _cssclass = 'inroute';
        break;
      }
      case '433': {
        _cssclass = 'failed';
        break;
      }
      default: {
        _cssclass = 'received';
        break;
      }
    }

    return _cssclass;
  }
}
